<template>
  <div class="flex flex-col w-full gap-2 bg-white rounded-lg">
    <div
      v-if="!notificationOpen"
      role="alert"
      class="relative flex w-full px-4 py-4 text-base text-red-900 bg-opacity-20 bg-red-900 rounded-lg font-regular"
      data-dismissible="alert"
    >
      <div class="mr-12 text-sm py-2 w-full flex">
        <span
          class="flex gap-2 landscape:items-center items-start justify-between w-full"
        >
          <div
            class="flex justify-center landscape:items-center items-start mr-2"
          >
            <i class="fa-solid fa-circle-info text-[20px] mr-2"></i>Your
            subscription has expired and your premium features are suspended.
          </div>
          <RouterLink
            to="/service-plans"
            class="bg-white border-0 p-2 text-xs font-medium text-main-600 align-middle transition-all rounded-lg select-none disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none hover:bg-white-900/10 active:bg-white-900/20 inline-flex items-center gap-1"
          >
            <i class="fas fa-repeat"></i>
            Renew
          </RouterLink>
        </span>
      </div>
      <button
        @click="handelNotification"
        data-dismissible-target="alert"
        class="!absolute top-3 right-3 h-8 max-h-[32px] w-8 max-w-[32px] select-none rounded-lg text-center align-middle text-xs font-medium uppercase text-main-900 transition-all hover:bg-white/30 active:bg-white/40 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        type="button"
      >
        <span
          class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
        >
          <i class="fa-solid fa-xmark text-[18px]"></i>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "StartUpAlertSubscription",
  computed: {
    ...mapGetters(["subscription"]),
    selectedStore() {
      return this.$store.getters.selectedStore;
    },
    notificationOpen() {
      const subscriptionData =
        this.subscription?.find((sub) => sub.storeId === this.selectedStore.id)
          ?.subscription || null;
      return subscriptionData
        ? true || subscriptionData.status === "active"
        : false;
    },
  },
  methods: {
    handelNotification() {
      this.notificationOpen = !this.notificationOpen;
      this.$emit("close");
    },
  },
};
</script>
